import React, { memo } from 'react';
import PropTypes from 'prop-types';
import Select from '../common/Select';
import CustomDatePicker from '../common/CustomDatePicker';

function formatDate(dateString) {
  const date = new Date(dateString);
  const formattedDay = String(date.getDate()).padStart(2, '0');
  const formattedMonth = String(date.getMonth() + 1).padStart(2, '0');

  return `${formattedDay}/${formattedMonth}/${date.getFullYear()}`;
}

function PreferredDateInput({ course, value, onChange }) {
  if (!course || course.selfStudyCourse || course.startDate) {
    return null;
  }

  const now = new Date();
  const upcomingDates = (course.coursePossibleDates || [])
    .filter((possibleDate) => new Date(possibleDate.date) > now)
    .sort((a, b) => new Date(a.date) - new Date(b.date));

  return (
    <div className="width100" style={{ marginTop: '10px' }}>
      <label>Preferred date (optional)</label>
      {upcomingDates.length > 0 ? (
        <Select
          options={upcomingDates.map((possibleDate) => ({ value: possibleDate.date, text: formatDate(possibleDate.date) }))}
          selected={value}
          changeHandler={onChange}
          placeholder="Pick a date"
        />
      ) : (
        <CustomDatePicker value={value || ''} onChange={onChange} placeholder="Preferred start date" className="form-control" />
      )}
    </div>
  );
}

PreferredDateInput.propTypes = {
  course: PropTypes.object,
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
};

export default memo(PreferredDateInput);
